import { ELEMENT_BLOCKQUOTE, ELEMENT_PARAGRAPH, ELEMENT_TODO_LI, isBlockAboveEmpty, isSelectionAtBlockStart, } from '@udecode/plate';
const resetBlockTypesCommonRule = {
    types: [ELEMENT_BLOCKQUOTE, ELEMENT_TODO_LI],
    defaultType: ELEMENT_PARAGRAPH,
};
export const resetBlockTypePlugin = {
    options: {
        rules: [
            Object.assign(Object.assign({}, resetBlockTypesCommonRule), { hotkey: 'Enter', predicate: isBlockAboveEmpty }),
            Object.assign(Object.assign({}, resetBlockTypesCommonRule), { hotkey: 'Backspace', predicate: isSelectionAtBlockStart }),
        ],
    },
};
//# sourceMappingURL=resetBlockTypePlugin.js.map